// Which website page and button sent this signup (GROW-192). The marketing site adds
// src_page and src_cta to its links to the app. They have to be read as soon as the app
// loads: Google sign-in leaves the app and comes back without them. sessionStorage keeps
// them for the tab, which survives that round trip.

const STORAGE_KEY = 'l2it_signup_source';
const CTA_POSITIONS = ['header', 'hero', 'pricing_card', 'in_article', 'final_pitch', 'footer', 'studio_handoff'];

function cleanPage(value) {
  // a path only, never a full url
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return undefined;
  return value.slice(0, 200);
}

function cleanCta(value) {
  return CTA_POSITIONS.includes(value) ? value : undefined;
}

export function captureSignupSource() {
  let url;
  try {
    url = new URL(window.location.href);
  } catch {
    return;
  }

  const hasParams = url.searchParams.has('src_page') || url.searchParams.has('src_cta');
  if (!hasParams) return;

  const sourcePage = cleanPage(url.searchParams.get('src_page'));
  const ctaPosition = cleanCta(url.searchParams.get('src_cta'));

  // a fresh click from the website is the real source, so it replaces an older one
  if (sourcePage || ctaPosition) {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          ...(sourcePage && { source_page: sourcePage }),
          ...(ctaPosition && { cta_position: ctaPosition }),
        }),
      );
    } catch {
      // storage blocked (private mode) - the signup just goes without a source
    }
  }

  url.searchParams.delete('src_page');
  url.searchParams.delete('src_cta');
  window.history.replaceState(window.history.state, document.title, url.href);
}

// { source_page?, cta_position? } - empty when the visitor didn't come from a website link
export function getSignupSource() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return {
      ...(cleanPage(parsed.source_page) && { source_page: parsed.source_page }),
      ...(cleanCta(parsed.cta_position) && { cta_position: parsed.cta_position }),
    };
  } catch {
    return {};
  }
}
